import { render, staticRenderFns } from "./SignatureListDoc.vue?vue&type=template&id=183308c8"
import script from "./SignatureListDoc.vue?vue&type=script&lang=js"
export * from "./SignatureListDoc.vue?vue&type=script&lang=js"
import style0 from "./SignatureListDoc.vue?vue&type=style&index=0&id=183308c8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports